export function setCookie( name, value, time) {
    if(time == -1){
        localStorage.removeItem(name);//为负数则删除此cookie
        return
    }
    localStorage.setItem(name, value);
}
 
export function getCookie(name) {
    return localStorage.getItem(name)?localStorage.getItem(name):false
  }
 
export function delCookie(c_name){
    localStorage.removeItem(c_name);
}
export function delAllCookie(){
    localStorage.clear();
}


// WEBPACK FOOTER //
// ./src/assets/js/cookie.js